
// .env.local file

// REACT_APP_FIREBASE_API_KEY=AIzaSyApcGd0CtAAtLo96PgHUuddIA06EsGf1jY
// REACT_APP_FIREBASE_AUTH_DOMAIN=agrikon-agricultural-website.firebaseapp.com
// REACT_APP_FIREBASE_PROJECT_ID=agrikon-agricultural-website
// REACT_APP_FIREBASE_STORAGE_BUCKET=agrikon-agricultural-website.appspot.com
// REACT_APP_FIREBASE_MESSAGING_SENDER_ID=1044736697194
// REACT_APP_FIREBASE_APP_ID=1:1044736697194:web:03f1d26189ca1a7b657b13









// console.log(process.env);
// const firebaseConfig = {
//     apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//     authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//     projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//     storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//     messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//     appId: process.env.REACT_APP_FIREBASE_APP_ID
// };






const firebaseConfig = {
    apiKey: "AIzaSyApcGd0CtAAtLo96PgHUuddIA06EsGf1jY",
    authDomain: "agrikon-agricultural-website.firebaseapp.com",
    projectId: "agrikon-agricultural-website",
    storageBucket: "agrikon-agricultural-website.appspot.com",
    messagingSenderId: "1044736697194",
    appId: "1:1044736697194:web:03f1d26189ca1a7b657b13"
};

export default firebaseConfig;